import MenuLink from "./MenuLink";
import { useTranslation } from "react-i18next";

const LessonsLink = () => {
  const { t } = useTranslation();
  return <MenuLink caption={t("nav.lessons")} to={"/lessons"} />;
};

export default LessonsLink;
